var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCountryAllowed
    ? _c(
        "div",
        { staticClass: "hidden-xs js-hideOnBottom" },
        [
          _c("div", { staticClass: "chatbox__wrapper" }, [
            _c(
              "a",
              {
                staticClass: "js-showChatBox",
                attrs: { href: "#js-chatbox-form" }
              },
              [
                _c(
                  "div",
                  { staticClass: "chatbox__image chatbox__image--pointer" },
                  [
                    _c("img", {
                      attrs: { src: _vm.image, alt: "Chat-Box available" }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            !_vm.chatAvailable
              ? _c("div", { staticClass: "chatbox__image" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.imageNotAvailable,
                      alt: "Chat-Box not available"
                    }
                  })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("ChatForm")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }